const mutationCallback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    for (const addedNode of mutation.addedNodes) {
      if (addedNode.id == 'onetrust-consent-sdk') {
        const settingsLink = addedNode.querySelector('#onetrust-policy-text a[onclick]');
        if (settingsLink) {
          settingsLink.onclick = null;
          settingsLink.addEventListener('click', (event) => {
            event.preventDefault();
            window.Optanon && window.Optanon.ToggleInfoDisplay();
            return false;
          });
        }
      }
    }
  }
};

export const connectOtObserver = () => {
  const observer = new MutationObserver(mutationCallback);
  observer.observe(document.body, { attributes: false, childList: true, subtree: false });
};

export const reloadOtBanner = () => {

  const otConsentSdk = document.getElementById("onetrust-consent-sdk");
  if (otConsentSdk) {
    otConsentSdk.remove();
  }

  if (window.OneTrust != null) {
    OneTrust.Init();

    setTimeout(function () {
      OneTrust.LoadBanner();

      var toggleDisplay = document.getElementsByClassName(
        "ot-sdk-show-settings"
      );

      for (var i = 0; i < toggleDisplay.length; i++) {
        toggleDisplay[i].onclick = function (event) {
          event.stopImmediatePropagation();
          window.OneTrust.ToggleInfoDisplay();
        };
      }
    }, 1000);
  }
}

const groupsRequiredForGTM = ['C0001', 'C0002', 'C0003', 'C0004'];
const otGroupsUpdatedCallback = (_event) => {
  // Yes, the variable is actually 'OnetrustActiveGroups', lowercase 't'.
  const hasAllFour = groupsRequiredForGTM.every(str => window.OnetrustActiveGroups.includes(str));
  if (!hasAllFour) {
    // At least one group disabled, reload the page
    location.reload();
  }
}

export const connectOtGroupsObserver = () => {
  window.addEventListener('OTConsentApplied', otGroupsUpdatedCallback);
};